export const STRINGS = {
  PAGE_TITLE: 'DeHaat | Contact Us',
  PAGE_DESCRIPTION:
    'DeHaat connects farmers to suppliers and buyers on a single platform. Online marketplace providing all the agricultural products and services to farmers.',
  CONTACT_US_AT: 'Contact us @',
  CONTACT_EMAIL_ID: 'contact@agrevolution.in',
  CONTACT_NUMBER: '1800 1036 110',
  CORPORATE_OFFICE_ADDRESS:
    'Unit No. 901, BPTP Park Centra, Sector-30, Gurugram, Haryana-122001',
  CORPORATE_OFFICE: 'Corporate Office',
  DROP_AN_ENQUIRY: 'Drop An Enquiry',
  FEEL_FREE_TO_CONTACT_US: 'Feel free to contact us',
  FREE_FARM_ADVISORY: 'Get free farming advisory',
  GET_IN_TOUCH: 'Get In Touch',
  HEAD_OFFICE_ADDRESS:
    'DeHaat Near MIG-33, Lohiyanagar, Kankarbagh, Patna, Bihar-800020',
  HEAD_OFFICE: 'Head Office',
}

export const CONTACT_FORM = {
  ENTER_EMAIL_LABEL: 'Email',
  ENTER_EMAIL_PLACEHOLDER: 'Enter Email ID',
  ENTER_ENQUIRY_TYPE_LABEL: 'Enquiry Type',
  ENTER_ENQUIRY_TYPE_PLACEHOLDER: 'Select Enquiry Type',
  ENTER_MESSAGE_LABEL: 'Message',
  ENTER_MESSAGE_PLACEHOLDER: 'Enter Message',
  ENTER_NAME_LABEL: 'Name',
  ENTER_NAME_PLACEHOLDER: 'Enter Name',
  PHONE_NUMBER_LABEL: 'Phone Number',
  PHONE_NUMBER_PLACEHOLDER: 'Phone Number',
  FARMER: 'Farmer',
  DEHAAT_BUSINESS_PARTNER: 'DeHaat Business Partner',
  INSTITUTIONAL_BUYER: 'Institutional Buyer',
  AGRI_INPUT_SUPPLIER: 'Agri Input Supplier',
}

export enum FORM_FIELD_NAME {
  EMAIL = 'Email',
  ENQUIRY_TYPE = 'Dropdown',
  MESSAGE = 'MultiLine',
  NAME = 'SingleLine',
  PHONE_NUMBER = 'PhoneNumber_countrycode',
}
